import { useRef } from 'react';
import type React from 'react';
import InvisibleInput from './InvisibleInput';
import CustomColorButton from './CustomColorButton';

type CustomColorPickerProps = {
  selectedColor: string | null;
  selectedColorIsCustom: boolean;
  onSelectColor: (color: string | null) => void;
};

const CustomColorPicker = ({
  selectedColor,
  selectedColorIsCustom,
  onSelectColor,
}: CustomColorPickerProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const customColor = selectedColorIsCustom ? selectedColor : null;

  const openColorPicker = (): void => {
    if (inputRef.current !== null) {
      inputRef.current.click();
    }
  };

  const handleColorInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    const newCustomColor = e.target.value;

    onSelectColor(newCustomColor);
  };

  return (
    <>
      <InvisibleInput
        type="color"
        onChange={handleColorInputChange}
        ref={inputRef}
      />
      <CustomColorButton customColor={customColor} onClick={openColorPicker} />
    </>
  );
};

export default CustomColorPicker;
